import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 isUserSubscribed:false,
 subscribeEmailAlreadyExists:false,
  loginModal: false,
  loginTab: "loginTab",
  location: "",
  isOtpVerificationModalRequired: false,
  propertyToSaveFrom: null,
  loginCallback: null,
  showTabsInModal:true,
  showSessionMsg:false,
  showContinueBtn:false,
  clearPasswordFlag: false
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLoginModal: (state, action) => {
      state.loginModal = action.payload;
    },
    setLoginTab: (state, action) => {
      state.loginTab = action.payload;
    },
    setLoginCallLocation: (state, action) => {
      state.location = action.payload;
    },
    setIsUserSubscribed:(state, action)=>{
      state.isUserSubscribed = action.payload;
    },
    setSubscribeEmailAlreadyExists:(state, action)=>{
      state.subscribeEmailAlreadyExists = action.payload;
    },
    setIsOtpVerificationModalRequired: (state, action) => {
      state.isOtpVerificationModalRequired = action.payload;
    },
    setPropertyToSaveFrom: (state, action) => {
      state.propertyToSaveFrom = action.payload;
    },
    setLoginCallback: (state, action) => {
      state.loginCallback = action.payload;
    },
    setShowTabsInModal : (state, action) => {
      state.showTabsInModal = action.payload;
    },
    setShowSessionMsg:(state,action)=>{
      state.showSessionMsg=action.payload
    },
    setShowContinueBtn:(state,action)=>{
      state.showContinueBtn=action.payload;
    },
    clearPassword: (state) => {
      state.clearPasswordFlag = !state.clearPasswordFlag;
    }
  },
});

export const {setLoginModal,setLoginTab , setLoginCallLocation,setIsUserSubscribed,setSubscribeEmailAlreadyExists,setIsOtpVerificationModalRequired, setPropertyToSaveFrom, setLoginCallback,setShowTabsInModal,setShowSessionMsg,setShowContinueBtn,clearPassword} = loginSlice.actions;
export default loginSlice.reducer;
